import { useEffect, useRef } from "react";
import useApiBanxico from "../../api/administracion/useApiBanxico";
import useApiConvenios from "../../api/comercial/convenios";
import useApiCotizaciones from "../../api/comercial/cotizaciones";
import useApiExpeditados from "../../api/comercial/expeditados";
import useApiSource from "../../api/source";

export default function ComercialNuevo() {
    const apiConvenios = useApiConvenios();
    const apiCotizaciones = useApiCotizaciones();
    const apiExpeditados = useApiExpeditados();
    const apiSource = useApiSource();
    const apiBanxico = useApiBanxico();

    const apiRef = useRef(null);

    apiRef.current = {
        convenios: apiConvenios,
        cotizaciones: apiCotizaciones,
        expeditados: apiExpeditados,
        source: apiSource,
        banxico: apiBanxico,
    };

    useEffect(() => {
        if (
            typeof window.mountComercial !==
            "function"
        ) {
            console.error(
                "No se encontró window.mountComercial. " +
                "Verifica que esté cargado ui-widget.iife.js."
            );

            return undefined;
        }

        console.log(
            "API entregada al microfrontend:",
            apiRef.current
        );

        console.log(
            "API Source:",
            apiRef.current?.source
        );

        const desmontar = window.mountComercial(
            "comercial-nuevo",
            {
                api: apiRef.current,
            }
        );

        return () => {
            if (typeof desmontar === "function") {
                desmontar();
            }
        };
    }, []);

    return <div id="comercial-nuevo" />;
}